import createMetas from './createMetas';

export const DEFAULT_MSAPP_CONFIG = 'none';
export const DEFAULT_MSAPP_TILE_SMALL =
  'https://static.spotahome.com/favicon/smalltile.png';
export const DEFAULT_MSAPP_TILE_MEDIUM =
  'https://static.spotahome.com/favicon/mediumtile.png';
export const DEFAULT_MSAPP_TILE_WIDE =
  'https://static.spotahome.com/favicon/widetile.png';
export const DEFAULT_MSAPP_TILE_LARGE =
  'https://static.spotahome.com/favicon/largetile.png';

const DEFAULT_PROPERTIES = {
  config: DEFAULT_MSAPP_CONFIG,
  tileSmall: DEFAULT_MSAPP_TILE_SMALL,
  tileMedium: DEFAULT_MSAPP_TILE_MEDIUM,
  tileWide: DEFAULT_MSAPP_TILE_WIDE,
  tileLarge: DEFAULT_MSAPP_TILE_LARGE
};

const PROPERTIES_MAP = {
  validate: 'msvalidate.01',
  config: 'msapplication-config',
  tileSmall: 'msapplication-square70x70logo',
  tileMedium: 'msapplication-square150x150logo',
  tileWide: 'msapplication-wide310x150logo',
  tileLarge: 'msapplication-square310x310logo'
};

export const createMsAppMetas = (props = {}) =>
  createMetas(props, DEFAULT_PROPERTIES, PROPERTIES_MAP);

export default {
  createMsAppMetas,
  DEFAULT_MSAPP_CONFIG,
  DEFAULT_MSAPP_TILE_SMALL,
  DEFAULT_MSAPP_TILE_MEDIUM,
  DEFAULT_MSAPP_TILE_WIDE,
  DEFAULT_MSAPP_TILE_LARGE
};
